module.exports = __webpack_public_path__ + "static/media/pokana-25.08.2023.5c25fc77.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2023/pokana-25.08.2023.pdf
// module id = 94
// module chunks = 0